import { render } from "./ParcelasPedidosCanceladosLiquidados.vue?vue&type=template&id=49770d21&scoped=true"
import script from "./ParcelasPedidosCanceladosLiquidados.vue?vue&type=script&lang=js"
export * from "./ParcelasPedidosCanceladosLiquidados.vue?vue&type=script&lang=js"

import "./ParcelasPedidosCanceladosLiquidados.vue?vue&type=style&index=0&id=49770d21&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49770d21"]])

export default __exports__